import React from 'react';
import { Pagination, useListContext } from 'react-admin';
import { Input } from '@mui/material';

const VariablePagination = () => {
  const { page, perPage, setPage, total } = useListContext();
  const totalPages = Math.ceil(total / perPage);

  const handlePageChange = (event) => {
    const pageNumber = parseInt(event.target.value, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <Pagination
        page={page}
        perPage={perPage}
        setPage={setPage}
        total={total}
        rowsPerPageOptions={[5,10,25,50,100,500]}
      />
      <Input
        type="number"
        value={page}
        onChange={handlePageChange}
        style={{ width: 50, marginLeft: 10 }}
      />
    </div>
  );
};


export default VariablePagination;
